var _circle, _mask, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewInvoicesOnTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#323232"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_187_400",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.7734,
    y: 15.5889,
    width: 25.9685,
    height: 32.4606,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.7734,
    y: 15.5889,
    width: 25.9685,
    height: 32.4606,
    rx: 2,
    stroke: "white",
    strokeWidth: 5,
    mask: "url(#path-2-inside-1_187_400)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0857 25.327V15.5889L44.7419 25.327H36.0857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9058 14.507V28.5732L35.0035 14.507H46.9058Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2887 44.4004L31.1487 36.8404L26.4087 29.5004H28.6487L32.6687 35.7604H31.8287L35.8487 29.5004H38.0887L33.3487 36.8404L38.2087 44.4004H35.9687L31.8287 37.9204H32.6687L28.5087 44.4004H26.2887Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewInvoicesOnTime);
export default __webpack_public_path__ + "static/media/review_invoices_on_time.94222c0cdc3679ea987d4f5f5679f481.svg";
export { ForwardRef as ReactComponent };